import Vue from 'vue'
const that = Vue.prototype
import requestPromisify from './promise.js';
import config from './config';
import go from '../go/go'
import md5 from 'js-md5';
console.log(config.host);
const url = {
    book: {
        lists: `${config.host}/book/lists`,
        moreLists: `${config.host}/book/more_list`,
        detail: `${config.host}/book/detail`,
        read: `${config.host}/book/read`,
        item_info: `${config.host}/book/item_info_auto`,
        favs:`${config.host}/book/favs`,
        shelflist:`${config.host}/book/favs_lists`,
        read_list:`${config.host}/book/read_list`,
        item_list:`${config.host}/book/item_list_page`,
        search:`${config.host}/book/lists`,
        hot_keywords:`${config.host}/book/hot_keywords`,
        comment_list:`${config.host}/book/book_comment_list`,
        comment_add:`${config.host}/book/book_comment_add`,
        comment_digg:`${config.host}/book/book_comment_digg`,
    },
    index: {
        lists: `${config.host}/miyue/index`,
        setLang: `${config.host}/miyue/setLang`,
        lastRead:`${config.host}/index/lastRead`,
        channel:`${config.host}/index/channel`,
        end:`${config.host}/index/end`,
        hots:`${config.host}/index/hots`,
        moreList:`${config.host}/index/more_list`,
    },
    user: {
        login: `${config.host}/user/login`,
        get: `${config.host}/user/get`,
        register:`${config.host}/user/register`,
        feedback:`${config.host}/feedback/add`,
        resetPassword:`${config.host}/user/resetPassword`,
        recharge:`${config.host}/user/recharge`,
        mycardpay:`${config.host}/user/mycardpay`,
        logout:`${config.host}/user/logout`,
        userBind:`${config.host}/user_bind/callback`,
    },
}

export default {
    register:function(email,password,sex,lang){
        var param = {
            "email": email,
            "password": md5(password),
            "sex": sex,
            "lang": lang,
        }
        return requestPromisify({
            url: url.user.register,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    errorHandel(err){
        that.$indicator.close();
        if(err.result=="请登录!"){
            go.goLogin();
        }else{
            that.$toast({
                message: err.result,
                duration: 3000
              });
        }
        
    },
    /**
     * 用户信息
     */
    getUser: function () {
        return requestPromisify({
            url: url.user.get,
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 设置语言
     */
    setLang: function (lang) {
        var param = {
            "lang":lang, 
        }
        return requestPromisify({
            url: url.index.setLang,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 充值
     */
    recharge:function(paytype,pay_pm_id,paynum,book_id){
        var param = {
            "pays":paytype, 
            "pay_pm_id":pay_pm_id, 
            "amount":paynum,
            "book_id":book_id
        }
        return requestPromisify({
            url: url.user.recharge,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            console.info(err);
            this.errorHandel(err);
        })
    },
    mycard:function(PaymentType,ItemCode,amount,book_id){
        var param = {
            amount: amount,
            book_id: book_id,
            ItemCode: ItemCode,
            PaymentType: PaymentType
        }
        return requestPromisify({
            url: url.user.mycardpay,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            console.info(err);
            this.errorHandel(err);
        })
    },
    /**
     * 修改密码
     */
    resetPassword: function (oldpwd,newpwd) {
        var param = {
            "type":2,
            "oldpassword":md5(oldpwd),
            "newpassword":md5(newpwd),
        }
        return requestPromisify({
            url: url.user.resetPassword,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 反馈
     */
    feedback:function(info){
        var param = {
            "info": info,
        }
        return requestPromisify({
            url: url.user.feedback,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 热门搜索
     */
    hot_keywords: function () {
        return requestPromisify({
            url: url.book.hot_keywords,
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 关键词搜索
     */
    search:function(page,keyword,cat_id){
        var param = {
            "page": page,
            "keyword": keyword,
            "cate_id":cat_id
        }
        return requestPromisify({
            url: url.book.search,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 首页列表
     */
    indexLists: function () {
        return requestPromisify({
            url: url.index.lists,
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 男女频
     */
    channel: function (sex) {
        var param = {
            "sex": sex,
        }
        return requestPromisify({
            url: url.index.channel,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 添加书架
     */
    favs:function(id){
        var param = {
            "book_id": id,
        }
        return requestPromisify({
            url: url.book.favs,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 目录列表
     */
    itemList:function(id,page,isOrder){
        var param = {
            "page": page,
            "id":id,
            "order":isOrder?"asc":"desc"
        }
        return requestPromisify({
            url: url.book.item_list,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 书架列表
     */
    shelflist:function(){
        return requestPromisify({
            url: url.book.shelflist,
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 最近阅读
     */
    readList:function(page){
        var param = {
            "page": page,
        }
        return requestPromisify({
            url: url.book.read_list,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 点赞
     */
    cmtDigg:function(id){
        var param = {
            "id": id,
        }
        return requestPromisify({
            url: url.book.comment_digg,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 评论列表
     */
    cmtList:function(id,page){
        var param = {
            "book_id": id,
            "page": page,
        }
        return requestPromisify({
            url: url.book.comment_list,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 添加评论
     */
    cmtAdd:function(id,cmt){
        var param = {
            "book_id": id,
            "info": cmt,
        }
        return requestPromisify({
            url: url.book.comment_add,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 上次阅读
     */
    indexLastRead:function(){
        return requestPromisify({
            url: url.index.lastRead,
        }).catch(err => {
            // console.log(err);
            that.$indicator.close();
            // that.$toast(err.result);
        })
    },
    /**
     * 书列表
     */
    lists: function () {
        return requestPromisify({
            url: url.book.lists,
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 完结列表
     */
    end: function (page) {
        var param = {
            "page": page,
        }
        return requestPromisify({
            url: url.index.end,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 人气榜
     */
    hots: function (page) {
        var param = {
            "page": page,
        }
        return requestPromisify({
            url: url.index.hots,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 推荐位更多
     */
    indexMoreList: function (typeid) {
        var param = {
            "type": typeid,
        }
        return requestPromisify({
            url: url.index.moreList,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 小说详情
     */
    bookDetail: function (id) {
        var param = {
            "id": id,
        }
        return requestPromisify({
            url: url.book.detail,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 立即阅读
     */
    bookRead:function(bookId){
        var param = {
            "id": bookId,
        }
        return requestPromisify({
            url: url.book.read,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     * 阅读章节
     */
    bookItem:function(itemId){
        var param = {
            "id": itemId,
        }
        return requestPromisify({
            url: url.book.item_info,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    moreLists: function (data) {
        return requestPromisify({
            url: url.book.moreLists,
            data: data
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    logout:function(){
        return requestPromisify({
            url: url.user.logout,
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    /**
     *用户操作  登录 注册 获取信息
     */
    login: function (name, pwd) {
        var param = {
            "tele": name,
            "password": md5(pwd)
        }
        return requestPromisify({
            url: url.user.login,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
    userBind: function (keyid,name) {
        var param = {
            "type": "fb",
            "username": name,
            "keyid": md5(keyid)
        }
        return requestPromisify({
            url: url.user.userBind,
            data: { data: JSON.stringify(param) }
        }).catch(err => {
            this.errorHandel(err);
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/request.js